import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { language } from "language/default";
const PREQIN_BENCHMARK_SOURCE = "Preqin Benchmark";
const INSIGHT_RESEARCH_SOURCE = "Insight Research";
const PREQIN_INDEX_SOURCE = "Preqin Index";
const mapSourceToBenchmarkSource = (rawSource) => {
    if (!rawSource) {
        return INSIGHT_RESEARCH_SOURCE;
    }
    const normalizedSource = rawSource.toLowerCase().trim();
    if (normalizedSource === "insight research") {
        return INSIGHT_RESEARCH_SOURCE;
    }
    if (normalizedSource === "preqin index" || normalizedSource.includes("policy")) {
        return PREQIN_INDEX_SOURCE;
    }
    if (normalizedSource === "preqin") {
        return PREQIN_BENCHMARK_SOURCE;
    }
    return rawSource;
};
export const PrivateBenchmarkListColDefs = [
    {
        field: "checkboxCol",
        floatingFilter: false,
        headerCheckboxSelection: true,
        headerName: " ",
        type: CustomColumnType.AUX_CHECKBOX_COLUMN,
        width: 32
    },
    {
        field: "name",
        headerName: language.en.markets.gridHeaderField.benchmarkName,
        sort: "asc",
        type: [CustomColumnType.AUX_TEXT_COLUMN]
    },
    { field: "source", headerName: language.en.common.source, type: [CustomColumnType.AUX_TEXT_COLUMN] },
    { field: "sizeClass", headerName: language.en.markets.gridHeaderField.sizeConstraint, hide: true, type: [CustomColumnType.AUX_TEXT_COLUMN] },
    { field: "strategy", headerName: language.en.markets.gridHeaderField.strategy, type: [CustomColumnType.AUX_TEXT_COLUMN] },
    { field: "geography", headerName: language.en.markets.gridHeaderField.geography, type: [CustomColumnType.AUX_TEXT_COLUMN] },
    { cellDataType: false, field: "vintage", headerName: language.en.markets.gridHeaderField.vintageYear, type: [CustomColumnType.AUX_TEXT_COLUMN] },
    { field: "constituents", headerName: language.en.markets.gridHeaderField.numberOfFunds, hide: true, type: [CustomColumnType.InsNumberColumn], width: 100 },
    { field: "medianNetIrr", headerName: language.en.funds.benchmark.medianNetIrr, hide: true, type: [CustomColumnType.InsPercentageColumn], width: 120 },
    { field: "medianTvpi", headerName: language.en.funds.benchmark.medianTvpi, hide: true, type: [CustomColumnType.InsMultiplyColumn], width: 100 }
];
export const getPrivateBenchmarkRows = (rows, filterFunc) => rows.map((row) => {
    const summary = row?.summary ?? row;
    const dataItem = row?.data?.[0];
    const mappedVintage = summary?.vintage === null || summary?.vintage === undefined || summary?.vintage === 0
        ? language.en.administration.marketDataAdministration.indices.zeroVintageType
        : summary?.vintage;
    return {
        ...summary,
        constituents: dataItem?.numberOfFunds,
        medianNetIrr: dataItem?.irr?.median,
        medianTvpi: dataItem?.tvpi?.median,
        source: mapSourceToBenchmarkSource(summary?.source),
        strategy: summary?.strategy && summary?.strategy === "Other"
            ? language.en.administration.marketDataAdministration.indices.otherStrategyType
            : summary?.strategy,
        type: summary?.type ?? language.en.administration.marketDataAdministration.indices.defaultStatisticsByPercentileType,
        vintage: mappedVintage
    };
}).filter(filterFunc);
